import { request } from "./apiRequest";
import type { NewsPost } from "../types/news.types";

export const newsClient = {
  getPosts: () => request<NewsPost[]>("/news"),

  createPost: (title: string, body: string) =>
    request<NewsPost>("/news/admin", {
      method: "POST",
      body: JSON.stringify({ title, body }),
    }),

  updatePost: (id: string, title: string, body: string) =>
    request<NewsPost>(`/news/admin/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: JSON.stringify({ title, body }),
    }),

  deletePost: (id: string) => request<void>(`/news/admin/${encodeURIComponent(id)}`, { method: "DELETE" }),

  uploadImage: (id: string, file: File) =>
    request<NewsPost>(`/news/admin/${encodeURIComponent(id)}/image?filename=${encodeURIComponent(file.name)}`, {
      method: "PUT",
      headers: { "Content-Type": file.type || "application/octet-stream" },
      body: file,
    }),

  removeImage: (id: string) => request<NewsPost>(`/news/admin/${encodeURIComponent(id)}/image`, { method: "DELETE" }),
};

/** Direct image src — not fetched via JS, used as an <img src>. */
export function newsImageUrl(id: string): string {
  return `/api/news/${encodeURIComponent(id)}/image`;
}
